import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { filter, first, map, Observable } from 'rxjs';
import { NotificationsFacade } from '../+state/notifications.facade';

@Injectable()
export class LoadUnreadNotificationsGuard implements CanActivate {
  constructor(private notificationsFacade: NotificationsFacade) {}

  canActivate(): Observable<boolean> {
    return this.checkStore();
  }

  checkStore(): Observable<boolean> {
    return this.notificationsFacade.isLoaded$.pipe(
      map((isLoaded) => {
        if (!isLoaded) {
          this.notificationsFacade.getUserUnreadNotifications();
          this.notificationsFacade.subscribeUserNotifications();
        }
        return isLoaded;
      }),
      filter((isLoaded) => isLoaded),
      first()
    );
  }
}
